import React, { useState, useEffect } from 'react'
import { Box, TextField, makeStyles } from '@material-ui/core'
import RichTextField from './RichTextField'
import { getRichBodyHtml } from '../utils/introRichText'

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
  },
}))

const BlurField = ({ value, onCommit, ...props }) => {
  const [local, setLocal] = useState(value || '')
  useEffect(() => { setLocal(value || '') }, [value])
  return (
    <TextField
      {...props}
      value={local}
      onChange={(e) => setLocal(e.target.value)}
      onBlur={() => { if (local !== (value || '')) onCommit(local) }}
    />
  )
}

const NotesEditor = ({ data, onChange }) => {
  const classes = useStyles()

  return (
    <Box className={classes.root}>
      <BlurField
        label="Page Title"
        value={data.title || ''}
        onCommit={(v) => onChange('title', v)}
        size="small"
        variant="outlined"
        fullWidth
      />

      <RichTextField
        label="Notes / Details"
        value={getRichBodyHtml(data)}
        onChange={(v) => onChange('bodyHtml', v)}
      />
    </Box>
  )
}

export default NotesEditor
